import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import rootReducer from './slices';

// Redux middleware
const middleware = [...getDefaultMiddleware({ thunk: true, serializableCheck: false })];

export default configureStore({
    reducer: rootReducer,
    middleware,
});
